import { render, staticRenderFns } from "./BaseTouchSpinStoryPrice.vue?vue&type=template&id=7ad6e5a4&scoped=true&"
import script from "./BaseTouchSpinStoryPrice.vue?vue&type=script&lang=js&"
export * from "./BaseTouchSpinStoryPrice.vue?vue&type=script&lang=js&"
import style0 from "./BaseTouchSpinStoryPrice.vue?vue&type=style&index=0&id=7ad6e5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad6e5a4",
  null
  
)

export default component.exports